// extracted by mini-css-extract-plugin
module.exports = {"melodyCardCategory":"Uv-z","categoryName":"Vv-z","categoryImage":"Wv-z","categoryContent":"Xv-z","bottomAligned":"Yv-z"};